import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { onChangeLightHeader } from "../store/CommonStore"; // Adjust the path if needed

const useHeaderColor = () => {
  const dispatch = useDispatch();
  const [scrollIndex, setScrollIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const windowHeight = window.innerHeight;
      const newIndex = Math.floor(currentScroll / windowHeight);

      if (newIndex !== scrollIndex) {
        setScrollIndex(newIndex);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollIndex]);

  useEffect(() => {
    dispatch(onChangeLightHeader(scrollIndex === 0));
  }, [scrollIndex, dispatch]);
};

export default useHeaderColor;
